module.exports = __webpack_public_path__ + "img/billing-bank.726475cb.png";